/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Col_ContentInputs */

const vi_station_work_col_content = /** @type {(inputs: Station_Work_Col_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung`)
};

/**

* @param {Station_Work_Col_ContentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_col_content = /** @type {((inputs?: Station_Work_Col_ContentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Col_ContentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_col_content(inputs)
});